const xxl = '(min-width: 135em)';
const xl = '(min-width: 105em)';
const lg = '(min-width: 90em)';
const md = '(min-width: 75em)';
const sm = '(min-width: 45em)';
const xs = '(max-width: 45em)';
export const breakpointValues = {
    xxl,
    xl,
    lg,
    md,
    sm,
    xs,
};
export const breakpoints = {
    xxl: `@media screen and ${xxl}`,
    xl: `@media screen and ${xl}`,
    lg: `@media screen and ${lg}`,
    md: `@media screen and ${md}`,
    sm: `@media screen and ${sm}`,
    xs: `@media screen and ${xs}`,
    desktop: `@media screen and ${md}`,
    mobile: `@media screen and (max-width: 75rem)`,
};
export const containerBreakpoints = {
    xxl: `@container ${xxl}`,
    xl: `@container ${xl}`,
    lg: `@container ${lg}`,
    md: `@container ${md}`,
    sm: `@container ${sm}`,
    xs: `@container ${xs}`,
};
